
import Vue from 'vue';

// A small label on the Feedback admin page: a report's kind, status, priority, tags, that its pull
// request merged, that an admin sent it, or that an agent filed or imported it. `kind` picks its
// colour: kind-bug, status-needs_human, priority-p0, merged, tag, admin, origin-import, and so on.
export default Vue.extend({
	name: 'FeedbackChip',
	props: {
		kind: { type: String, required: true },
		label: { type: String, required: true },
	},
});
